import { fromJS } from 'immutable';

import {
	UPDATE_REFERRER_SETTINGS,
	UPDATE_REFERRER_SETTINGS_SUCCESS,
	UPDATE_REFERRER_SETTINGS_ERROR,
	FETCH_REFERRER_SETTINGS,
	FETCH_REFERRER_SETTINGS_SUCCESS,
	FETCH_REFERRER_SETTINGS_ERROR,
	RESET_REFERRER_SETTINGS_SAVED,
} from './constants';

const initialState = fromJS({
	saving: false,
	saved: false,
	loading: false,
	notifyEmail: true,
	notifySms: false,
});

function referrerSettingsReducer(state = initialState, action) {
	switch (action.type) {
		case UPDATE_REFERRER_SETTINGS:
			return state.set('saving', true).set('saved', false);
		case UPDATE_REFERRER_SETTINGS_SUCCESS:
			return state.set('saving', false).set('saved', true);
		case UPDATE_REFERRER_SETTINGS_ERROR:
			return state.set('saving', false);
		case FETCH_REFERRER_SETTINGS:
			return state.set('loading', true);
		case FETCH_REFERRER_SETTINGS_SUCCESS:
			return state
				.set('loading', false)
				.set('notifyEmail', action.data.notifyEmail)
				.set('notifySms', action.data.notifySms);
		case FETCH_REFERRER_SETTINGS_ERROR:
			return state.set('loading', false);
		case RESET_REFERRER_SETTINGS_SAVED:
			return state.set('saved', false);
		default:
			return state;
	}
}

export default referrerSettingsReducer;
